/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ organization: NonNullable<unknown> }} Org_Switcher_RemoveInputs */



/**
* | output |
* | --- |
* | "Remove {organization} from this list" |
*
* @param {Org_Switcher_RemoveInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const org_switcher_remove = /** @type {((inputs: Org_Switcher_RemoveInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Org_Switcher_RemoveInputs, { locale?: "en" | "de" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ (`${i?.organization} aus der Liste entfernen`)
	return /** @type {LocalizedString} */ (`Remove ${i?.organization} from this list`)
});